import React, { useContext, ReactNode } from 'react';
import { Route } from 'react-router-dom';

import SubNavigation from 'components/SubNavigation/SubNavigation';
import Radio from '../Airplay/Radio';
import Discoveries from '../Airplay/Discoveries';

import { airplaySubTopics } from 'topics';
import { IEntityPageComponentProps } from 'pages/Entity/shared';
import { EntityContext } from 'context/entityContext';
import TopicFilters from 'components/TopicFilters/TopicFilters';

const VersionAirplay: React.FC<IEntityPageComponentProps> = (props) => {
  const { match, pathPrefix } = props;
  const { entityId, parentEntityId } = match.params;

  const { compareMode, topic } = useContext(EntityContext);

  return (
    <>
      <SubNavigation topic="airplay" variants={airplaySubTopics} />
      <TopicFilters topic={topic[1] || topic[0]} compareMode={compareMode} />

      <Route
        exact
        path={`${pathPrefix}/track/${parentEntityId}/version/${entityId}/airplay/radio`}
        render={(): ReactNode => <Radio />}
      />
      <Route
        exact
        path={`${pathPrefix}/track/${parentEntityId}/version/${entityId}/airplay/discoveries`}
        render={(): ReactNode => <Discoveries />}
      />
    </>
  );
};

export default VersionAirplay;
